import moment from 'moment';

angular.module('mx.SolutionBuilderAgent').component('mxConditionDate', {
	bindings: { condition: '=' },
	controller: MxConditionDateCtrl,
	controllerAs: 'vm',
	templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-condition-builder/by-type/mx-condition-date.html',
});

MxConditionDateCtrl.$inject = ['mx.internationalization', 'mx.SolutionBuilderAgent.ConditionsBuilder.Enums'];

function MxConditionDateCtrl(i18n, conditionsBuilderEnums) {
	const vm = this;
	const ConditionDateMods = conditionsBuilderEnums.ConditionDateMods;
	vm.ConditionDateMods = ConditionDateMods;
	vm.i18n = i18n.get('solutionBuilderAgent.components.mx-conditions-builder');
	vm.modes = [
		{
			id: ConditionDateMods.Date,
			title: vm.i18n.exactDate,
		},
		{
			id: ConditionDateMods.DateExpression,
			title: vm.i18n.dateExpression,
		},
	];

	let expression = '';
	let mode;
	let date = new Date();

	Object.defineProperty(vm, 'mode', {
		get: function () {
			return mode;
		},
		set: function (value) {
			mode = value;

			if (mode === ConditionDateMods.Date) {
				vm.condition.value = date.toISOString();
			} else {
				vm.condition.value = expression;
			}
		},
	});

	Object.defineProperty(vm, 'expression', {
		get: function () {
			return expression;
		},
		set: function (value) {
			expression = value || '';
			vm.condition.value = expression;
		},
	});

	Object.defineProperty(vm, 'date', {
		get: function () {
			return date;
		},
		set: function (newDate) {
			date = newDate;
			if (newDate instanceof Date) {
				vm.condition.value = newDate.toISOString();
			} else {
				vm.condition.value = '';
			}
		},
	});

	vm.$onInit = function () {
		if (Array.isArray(vm.condition?._builderConfig?.availableDateMods)) {
			vm.modes = vm.modes.filter((mode) => vm.condition?._builderConfig?.availableDateMods.includes(mode.id));
		}

		const modeIds = vm.modes.map((mode) => mode.id);
		const inputDate = moment(vm.condition.value, moment.ISO_8601);
		if (modeIds.includes(ConditionDateMods.Date) && inputDate.isValid()) {
			mode = ConditionDateMods.Date;
			date = inputDate.toDate();
		} else if (modeIds.includes(ConditionDateMods.DateExpression)) {
			mode = ConditionDateMods.DateExpression;
			expression = vm.condition.value || '';
		} else {
			mode = modeIds[0];
			vm.condition.value = mode === ConditionDateMods.Date ? date : expression;
		}
	};
	return vm;
}
